import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { callApiGetEnvironmentData } from './apiCalls';
import { catchWithAuthErrors, addErrorNotice } from '../../Helpers/rxjsHelpers';
import { actions } from '.';

export const getData = (action$) =>
  action$.pipe(
    ofType(actions.getEnvironmentData.toString()),
    switchMap(() => {
      return callApiGetEnvironmentData().pipe(
        switchMap((data) =>
          of(
            actions.getEnvironmentDataResolve({
              data,
            })
          )
        ),
        catchWithAuthErrors((err) =>
          of(actions.getEnvironmentDataReject(), addErrorNotice('Failed to retrieve environment data', err))
        )
      );
    })
  );
